import { Loader } from '@/constants';
import { bus } from '@/main';
import { Photos } from '@/types';

const sortByDate = <T>(data: T[], sortBy: number) => {
  return data.sort((a: any, b: any) =>
    sortBy === -1
      ? Date.parse(b.modifiedDate) - Date.parse(a.modifiedDate)
      : sortBy === 1
        ? Date.parse(a.modifiedDate) - Date.parse(b.modifiedDate)
        : 0
  );
};

const checkImageUrl = async (allPhotos: Photos[]) => {
  const correctPhotos = [] as Photos[];
  await Promise.all(allPhotos.map(photo => new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      correctPhotos.push(photo);
      resolve(null);
    };
    img.onerror = () => {
      resolve(null);
    };
    img.src = photo.assetValue;
  })));
  return correctPhotos;
}

const getPhaseCompletionStatus = (value?: string): string => {
  const progress = value?.toLowerCase().trim();
  return progress === 'completed'
    ? 'completed' : progress === 'in progress'
      ? 'inprogress' : '';
};

const getPhaseIcon = (phase: string) => {
  phase = phase.toLowerCase();
  return {
    ariaLabel: `phase-${phase}`,
    href: require('@/assets/images/icons.svg') + `#phase_${phase}`
  };
};

const getInitials = (firstName: string, lastName: string) => {
  const name = firstName.trim().split(' ');
  name.push(lastName);
  return name.map((value) => value.charAt(0).toUpperCase()).join('');
};

const isMobile = () => (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));

export const isIOS = () => {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform) ||
  (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
};

const showLoader = () => bus.$emit(Loader.SHOW);

const hideLoader = () => bus.$emit(Loader.HIDE);

const standardCasing = (value: string): string => {
  const names = value.split(' ');
  return names
    .map((x) => `${x.charAt(0).toUpperCase()}${x.slice(1)}`)
    .join(' ');
};

const formatPrice = (value: string): string => {
  const price = value ? +value : 0;
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  });
  return formatter.format(price);
};

const convertDateFormat = (date: string) => {
  const initial = date.split(/\//);
  return [initial[2], initial[1], initial[0]].join('-');
};

const setDateFormat = (date: string) => {
  const initial = date.split('-');
  return [initial[2], initial[1], initial[0]].join('/');
};

const isEmptyObject = (data: {}) => (Object.keys(data).length === 0 && data.constructor === Object);

const getRandomNumber = (min = 0, max = 100) => Math.floor(Math.random() * (max - min + 1)) + min;

export {
  sortByDate,
  getPhaseCompletionStatus,
  getPhaseIcon,
  getInitials,
  isMobile,
  showLoader,
  hideLoader,
  standardCasing,
  formatPrice,
  convertDateFormat,
  setDateFormat,
  isEmptyObject,
  getRandomNumber,
  checkImageUrl
};
